import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function getCompanyName(): string {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (7,5): Type 'RecursiveReadOnly<string | undefined>' is not assignable to type 'string'.
    // @ts-expect-error
    return getUserConfiguration().SessionSettings.CompanyName;
}
